<template>
  <!--收货地址-->
  <div class="address">
    <div class="addressPc">
      <el-form class="addressForm" ref="form" :model="form" label-width="80px">
        <el-form-item label="氏名" prop="name">
          <el-input v-model="form.name" style="width: 200px"></el-input>
          <span class="tishi">届ける送り先を入力してください</span>
        </el-form-item>
        <el-form-item label="都道府県">
          <el-cascader :options="options2" @active-item-change="handleItemChange" :props="props"></el-cascader>
        </el-form-item>
        <el-form-item label="詳細住所">
          <el-input v-model="form.address" style="width: 500px"></el-input>
          <div class="tishi">詳細住所/アドレス情報を入力してください</div>
        </el-form-item>
        <el-form-item label="携帯番号">
          <el-input class="input-with-select" style="width: 200px"></el-input>
          <span class="tishi">電話番号を入力してください</span>
        </el-form-item>
        <el-form-item>
          <el-checkbox label="電話番号を入力してください"></el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-button>保存</el-button>
        </el-form-item>
      </el-form>
      <el-alert title="お届け先は５個まで追加登録できます" type="success" :closable="false"></el-alert>
      <el-table stripe :data="tableData3" height="250" border>
        <el-table-column prop="name" label="お届け先氏名" width="99"></el-table-column>
        <el-table-column prop="city" label="都道府県" width="130"></el-table-column>
        <el-table-column prop="address" label="詳細住所" width="230"></el-table-column>
        <el-table-column prop="tel" label="携帯番号" width="150"></el-table-column>
        <el-table-column label="設定" width="100">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="text" size="small">修改</el-button>
            <el-button @click="detial(scope.row)" type="text" size="small">削除</el-button>
          </template>
        </el-table-column>
        <el-table-column width="142">
          <template slot-scope="scope">
            <el-button @click="setting_address" type="text" size="small">よく使うお届け先住所</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!--手机HTML-->
    <div class="addressM">
      <p class="addressTop">
        <span @click="back"><img src="../../assets/images/users/Return.png"></span>
        <span>受け取り先</span>
        <span></span>
      </p>
      <el-form class="addressPhone" ref="form" :model="form" label-width="60px">
        <el-form-item label="氏名" prop="name">
          <el-input v-model="form.name" style="width: 200px"></el-input>
          <!--<p class="tishi">请填写真实姓名，以便为您及时投递和配送</p>-->
        </el-form-item>
        <el-form-item label="都道府県">
          <el-cascader :options="options2" @active-item-change="handleItemChange" :props="props"></el-cascader>
        </el-form-item>
        <el-form-item label="詳細住所">
          <el-input v-model="form.address"></el-input>
          <!--<p class="tishi">请填写详细准确的地址（例如:学校填写班级；小区填写几栋几室；大厦填写几室和公司名称）</p>-->
        </el-form-item>
        <el-form-item label="携帯番号">
          <el-input class="input-with-select" style="width: 200px"></el-input>
          <!--<p class="tishi">请填写方便与您联系的手机号</p>-->
        </el-form-item>
        <el-form-item>
          <el-checkbox label="よく使うお届け先住所"></el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-button>セーブ</el-button>
        </el-form-item>
      </el-form>
      <p class="addressList"><span>收货地址列表</span></p>
      <ul class="addressmMain">
        <li>
          <div class="aMainText">
            <p><span>收件人:吴守佩</span><span>联系电话:15517070262</span></p>
            <p>详细地址:浙江省杭州市余杭区梦想小镇1399号4号楼1楼</p>
          </div>
          <div class="aMainEdit">
            <span class="aMainEditLeft">
              <input type="checkbox">
              <label>设置为默认地址</label>
            </span>
            <div class="aMainEditRight">
              <span>修正</span>
              <span>削除</span>
            </div>

          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default{
    name: "",
    data(){
      return {
        tableData3: [
          {
            id: 0,
            name: '王小虎',
            city: "浙江省杭州市余杭区",
            address: '仓前街道昌源清苑7幢5单元801',
            tel: '18557536873',
          },
        ],
        select: "",
        edit: false,
//        CityInfo: CityInfo,//地区数据
        form: {
          tel: "",
          name: "",
          address: "",
          city: '',
          erae: '',
          minerae: '',
          selectedOptions: [],//地区筛选数组
        },
        options2: [
          {
            label: '江苏',
            cities: []
          },
          {
            label: '浙江',
            cities: []
          }],
        props: {
          value: 'label',
          children: 'cities'
        }
      }
    },
    created(){
    },
    methods: {
      back(){
        this.$router.go(-1)
      },
      handleClick(row) {//修改
        console.log(row);
        this.form.name = row.name
        this.form.tel = row.tel
        this.form.address = row.address
      },
      detial(row){
        console.log(row);
        console.log("删除");
      },
      setting_address(){
        console.log("默认地址");
      },
      handleItemChange(val) {
        console.log('active item:', val);
        setTimeout(_ => {
          if (val.indexOf('江苏') > -1 && !this.options2[0].cities.length) {
            this.options2[0].cities = [{
              label: '南京'
            }];
          } else if (val.indexOf('浙江') > -1 && !this.options2[1].cities.length) {
            this.options2[1].cities = [{
              label: '杭州'
            }];
          }
        }, 300);
      }
    },
  }
</script>
<style lang="scss">
  @import "../../../static/pubilc";

  @media screen and(min-width: $min-screen) and(max-width: $P749screen) {
    .address {
      .addressPc {
        display: none;
      }
      .addressM {
        .addressTop {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          height: 50px;
          background-color: $TitColor;
          display: flex;
          justify-content: space-between;
          line-height: 50px;
          color: $whiteColor;
          z-index: 999;
          span:nth-child(1),
          span:nth-child(3) {
            width: 50px;
            display: inline-block;
            height: 50px;
            img {
              margin-top: 10px;
              margin-left: 10px;
            }
          }
        }
        .addressPhone {
          /*position: absolute;*/
          /*top: 60px;*/
          /*left: 0;*/
          /*right: 0;*/
          /*bottom: 0;*/
          /*overflow-x: hidden;*/
          /*overflow-y: scroll;*/
          width: 100%;
          padding: 0 1%;
          margin-top: 70px;
          box-sizing: border-box;
          background-color: #f6f7f9;
          label {
            font-size: 12px;
            padding: 0 5px 0 0;
          }
          .el-form-item {
            margin-bottom: 18px;
            .el-button {
              padding: 8px 10px;
            }
          }
          .el-select {
            width: 130px;
          }
        }
        .addressList {
          height: 30px;
          width: 100%;
          background-color: #f6f6f6;
          color: #dddddd;
          span {
            display: inline-block;
            margin-left: 10px;
            line-height: 30px;

          }
        }
        .addressmMain {
          margin-bottom: 55px;
          width: 100%;
          font-size: 14/$default-w+rem;
          li {
            width: 98%;
            padding: 0 1%;
            background-color: white;
            margin: 5px 0;
            border-bottom: 1px solid #dddddd;
            .aMainText {
              width: 100%;
              p {
                padding-right: 2%;
              }
              p:nth-child(1) {
                width: 98%;
                height: 25px;
                font-size: 14/$default-w+rem;
                line-height: 25px;
                display: flex;
                justify-content: space-between;
              }
              p:nth-child(2) {
                width: 98%;
                height: 50px;
                line-height: 25px;
                font-size: 14/$default-w+rem;
              }
            }
            .aMainEdit {
              width: 100%;
              border-top: 1px dashed #dddddd;
              display: flex;
              justify-content: space-between;
              line-height: 25px;
              padding: 5px 0;
              .aMainEditLeft {
                display: flex;
                align-items: center;
                label {
                  font-size: 14/$default-w+rem;
                }
              }
              .aMainEditRight {
                span {
                  text-align: center;
                  display: inline-block;
                  width: 2rem;
                }
              }
            }
          }
        }
      }
    }
  }

  @media screen and(min-width: $P750screen) {
    .address {
      background-color: $bgcolor;
      .addressPc {
        .addressForm {
          padding-top: 20px;
          /*width: 852px;*/
          .tishi {
            color: $fontColor;
            height: 20px;
            line-height: 20px;
          }
          .el-form-item {
            .el-form-item__label,
            .el-cascader__label,
            .el-input__inner,
            .el-cascader {
              height: 35px;
              line-height: 35px;
            }
            .el-button {
              padding: 8px 10px;
            }
          }
          .el-select {
            width: 130px;
          }
        }
        .el-table {
          margin-top: 10px;
          width: 100%;
          text-align: center;
          .is-leaf {
            background-color: #ebecf0;
          }
          .cell {
            text-align: center;
          }
          button {
            color: $fontColor;
          }
        }
      }
      .addressM {
        display: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/personal/address.vue